import { BaseConfig } from '../ServiceConfig';

export interface TicketConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.TicketServiceConfigData';
  url: string;
}

export const TicketConfigurationFields: (keyof TicketConfiguration)[] = ['url'];

export const BlankTicketConfiguration: TicketConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.TicketServiceConfigData',
} as TicketConfiguration;
